import script from "./LoadingBar.vue?vue&type=script&setup=true&lang=js"
export * from "./LoadingBar.vue?vue&type=script&setup=true&lang=js"

import "./LoadingBar.vue?vue&type=style&index=0&id=a0d1d9d8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a0d1d9d8"]])

export default __exports__